function ClipboardCheckIcon() {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <rect x='5.5' y='4.5' width='13' height='16.5' rx='2' />
      <path d='M9 4.5V3h6v1.5M9 13l2.2 2.2L15.5 11' />
    </svg>
  )
}

export default ClipboardCheckIcon
